import React from "react"
import { Route } from "react-router-dom"
import slugify from "slugify"
import LibraryCategory from "./LibraryCategory"
import L10n from "lib/carrot-l10n"
import LibraryNavigation from "./LibraryNavigation"
import { BodyWithLeftSidebarLayout } from "../atoms/Layouts"
import { useSelector } from "react-redux"
import { PageHeader } from "../molecules/Molecules"
import { MasterLayout } from "../atoms/layouts/MasterLayout"
import { getLibraryCategories } from "derivedSelectors/librarySelectors"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const LibraryHeader = () => <PageHeader icon="icn-read-learn" title={l`client.library.title`} />

const LibraryMainContent = () => {
  const categories = useSelector(getLibraryCategories)
  return (
    <div className="flex flex-column flex-row-l">
      {categories.map((category) => (
        <Route
          key={category.sys.id}
          exact
          path={`/read/${slugify(category.fields.title)}`}
          component={() => <LibraryCategory category={category} />}
        />
      ))}
    </div>
  )
}

const Library = () => (
  <MasterLayout header={<LibraryHeader />}>
    <BodyWithLeftSidebarLayout
      contentId="library-content"
      sideBarElements={[<LibraryNavigation key="library-navigation" />]}
    >
      <LibraryMainContent />
    </BodyWithLeftSidebarLayout>
  </MasterLayout>
)

export default Library
